import React, { Fragment } from "react"
import PropTypes from "prop-types"
import SectionCompanyUserAccess from "../CompanyUserAccess/CompanyUserAccess"
import SectionOneManduUser from "./Forms/sectionOneManduUser"
import SectionTwoManduUser from "./Forms/sectionTwoManduUser"
import SectionThreeSupport from "./Forms/sectionThreeSupport"

const UserManduCreate = (props) => {
  const { companiesUserAccesses } = props.currentData
  const { companies } = props.userCreate
  if (props.setIdUserToItemsCompany == null) {
    return <div />
  }
  return (
    <Fragment>
      <SectionOneManduUser {...props} />
      <SectionTwoManduUser {...props} />
      <SectionThreeSupport {...props} />
      <SectionCompanyUserAccess
        items={props.setIdUserToItemsCompany(companies, null)}
        dataSource={props.setIdUserToItemsCompany(companiesUserAccesses, null)}
        {...props}
      />
    </Fragment>
  )
}

UserManduCreate.propTypes = {
  currentData: PropTypes.object,
  setIdUserToItemsCompany: PropTypes.func,
}

export default UserManduCreate
